'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionsDeficiencies', ['$scope', 'IPDeficiencies', function ($scope, IPDeficiencies) {
        $scope.loading = true;

        IPDeficiencies.get().then(function (deficiencies) {
            $scope.deficiencies = deficiencies;
            $scope.deficiencies.isRequiredYesNo = ('Yes');
            $scope.loading = false;
        })

        $scope.columns = [
            {
                label: 'Name',
                field: 'name',
                link: {
                    state: 'internal.inspecting.resource.deficiency',
                    params: [
                        {
                            name: 'id',
                            field: 'id'
                        },
                        {
                            name: 'deficiency',
                            field: ''
                        }
                    ]
                }
            },
            {
                label: 'Question',
                field: 'question'
            },
            {
                label: 'Code',
                field: 'code'
            },
            {
                label: 'Category',
                field: 'deficiency_category.name'
            },
            {
                label: 'Required',
                field: 'required',
                type: 'yesno'
            }
        ];

        $scope.filters = [
            {
                name: 'Category',
                field: 'deficiency_category_id',
                service: 'IPDeficiencyCategories'
            }
        ]
    }])
;